module.exports = __webpack_public_path__ + "static/media/LifterGirl.05e56ad0.jpg";